import DefaultCard from "components/common/Card/DefaultCard";
import React, { FC } from "react";
import styles from "./index.module.scss";
import { useLifeChoicePageContext } from "context/hooks/useLifeChoicePageContext";
import { t } from "i18next";

const CareerInfoContent: FC = () => {
  const { lifeChoice } = useLifeChoicePageContext();

  return (
    <div
      className={`${styles["career-info-content"]} | grid`}
      style={{ "--cols-mobile": 2, "--cols": 4 } as any}
    >
      {lifeChoice.profession_growth ? (
        <DefaultCard className={styles["info-card"]}>
          <h5 className="text-sm lg:text-base">
            {t("professionGrowth") as string}
          </h5>
          <h1>{lifeChoice.profession_growth}</h1>
        </DefaultCard>
      ) : (
        ""
      )}
      {lifeChoice.annual_openings.average ? (
        <DefaultCard className={styles["info-card"]}>
          <h5 className="text-sm lg:text-base">
            {t("annualOpenings") as string}
          </h5>
          <h1>{lifeChoice.annual_openings.average.toLocaleString()}</h1>
        </DefaultCard>
      ) : (
        ""
      )}
      {lifeChoice.yearly_graduated ? (
        <DefaultCard className={styles["info-card"]}>
          <h5 className="text-sm lg:text-base">
            {t("yearlyGraduated") as string}
          </h5>
          <h1>{lifeChoice.yearly_graduated.toLocaleString()}</h1>
        </DefaultCard>
      ) : (
        ""
      )}
      {lifeChoice.junior_openings ? (
        <DefaultCard className={styles["info-card"]}>
          <h5 className="text-sm lg:text-base">
            {t("juniorOpportunities") as string}
          </h5>
          <h1>{lifeChoice.junior_openings.toLocaleString()}</h1>
        </DefaultCard>
      ) : (
        ""
      )}
    </div>
  );
};

export default CareerInfoContent;
